/** Hostname-based environment detection (Prod / Develop / Sandbox / Local). */
export type Environment = {
  label: "Prod" | "Develop" | "Sandbox" | "Local";
  /**
   * Tailwind utility set for the env pill — border / soft background /
   * text + dot. Uses the standard *-mid / *-dim / full triplets so every
   * env reads as the same visual shape, just a different tone.
   */
  toneClass: string;
  dotClass: string;
};

export function detectEnvironment(hostname = window.location.hostname): Environment {
  switch (hostname) {
    case "powerup.pilotenergy.com":
      return {
        label: "Prod",
        toneClass: "border-success-dim bg-success-dim text-success",
        dotClass: "bg-success",
      };
    case "powerup.dev.pilotenergy.com":
      return {
        label: "Develop",
        toneClass: "border-warning-mid bg-warning-dim text-warning",
        dotClass: "bg-warning",
      };
    case "powerup.sandbox.pilotenergy.com":
      return {
        label: "Sandbox",
        toneClass: "border-warning-mid bg-warning-dim text-warning",
        dotClass: "bg-warning",
      };
    default:
      return {
        label: "Local",
        toneClass: "border-primary-mid bg-primary-dim text-primary",
        dotClass: "bg-primary",
      };
  }
}
